<template>
  <el-dialog
          title="云喇叭管理"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
          customClass="customWidth"
          append-to-body
  >
    <el-button
            type="primary"
            size="mini"
            icon="el-icon-circle-plus"
            @click="add"
    >
      新增
    </el-button>
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >


      <el-table-column
              label="id"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>

      <el-table-column
              label="设备id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.sb_sn}}

        </template>
      </el-table-column>
      <el-table-column
              label="类型"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type=='0' || scope.row.type=='' ">
            云喇叭
          </div>
          <div v-else-if="scope.row.type=='1'">
            B001云喇叭
          </div>
          <div v-else-if="scope.row.type=='3'">
            二合一喇叭
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            启用
          </div>
          <div v-else-if="scope.row.state=='1'">
            未启用
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="备注"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.remarks}}
        </template>
      </el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="150"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
          <el-button type="primary" plain size="mini"    @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>

    </div>
    <editspeaker-form
            :agent="oneclass"
            v-model="editFormVisible2"
            :store_id="store_id"
            :accuseVisible="accuseVisible2"
            @submit="getTableData33"
    />
  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import editspeakerForm from "./editspeakerForm";
    import util from '@/libs/util.js'
    export default {
        name: "cloudEditForm",
        components: { editspeakerForm},
        props: {
            agent: Object,
            accuseVisible:Boolean,
            value: Boolean
        },
        data() {
            return {
                loading: false,
                pos:0,
                dialogVisible: false,
                accuseVisible2:true,
                store_id:0,
                tableData: [],
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                oneclass: {},
                editFormVisible2: false,
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dialogOpen() {
                this.getTableData33();

            },
            getTableData33() {

                console.info("===========ddddddddd========="+this.agent.id);
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    descending: this.sort.order === "descending",
                    store_id: this.agent.id
                };
                agentService.getAgentStoreSpeakerPagelist(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData33();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData33();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData33();
            },
            del(id) {
                this.$confirm("确认删除？", "确认信息", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "删除",
                    cancelButtonText: "取消"
                }).then(() => {
                    agentService.delAgentStoreSpeaker({id:id}).then(() => {
                        this.getTableData33();
                    });
                });
            },
            add() {
                this.oneclass = {};
                this.editFormVisible2 = true;
                this.store_id=this.agent.id;
            },
            openEditForm(oneclass) {
                this.oneclass = oneclass;
                this.editFormVisible2 = true;
                this.accuseVisible2=true;
            },
            close() {
                this.dialogVisible = false;
            }
        }
    };
</script>
<style>
  .customWidth{
    width:80%;
  }
</style>
